import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const TermsAndPolicies = () => {
  const termsData = [
    {
      id: 1,
      title: 'Purpose of Service',
      description: (
        <>
          <p className="text-white/80 leading-relaxed">
            CityPermit.ai provides assistance with preparing and submitting building permit applications to the appropriate City department on your behalf.
          </p>
          <p className="text-white/80 leading-relaxed mt-2">
            CityPermit.ai does not issue permits; permits are granted solely by your City's Building & Safety Department.
          </p>
        </>
      ),
    },

    {
      id: 2,
      title: 'Accuracy of Information',
      description: 'By using our service, you confirm that:',
      subPoints: [
        'All information provided is true, accurate, and complete.',
        'Any uploaded plans, drawings, or documents belong to you or you are authorized to submit them.',
        'You understand that inaccurate or incomplete information may delay City review.',
      ],
    },
    {
      id: 3,
      title: 'Authorization to Submit',
      description: 'By continuing, you authorize CityPermit.ai to:',
      subPoints: [
        'Prepare your permit submission package,',
        'Submit your application to the City,',
        'Communicate with the City regarding your application status if required.',
      ],
      footer: 'You may revoke authorization at any time by contacting support.',
    },
  ];

  return (
    <div className="min-h-screen bg-[#1A1A1A] text-white overflow-y-auto font-baloo-2">
      {/* Header */}
      {/* <div className="sticky top-0 bg-[#1A1A1A] border-b border-white/10 z-10">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 py-4">
          <Link to="/" className="inline-flex items-center gap-2 text-white/70 hover:text-white transition-colors">
            <ArrowLeft className="w-5 h-5" />
            <span>Back</span>
          </Link>
        </div>
      </div> */}

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-8 sm:py-12">
        <div className="mb-8 sm:mb-12 text-center">
          <h1 className="text-3xl sm:text-4xl font-bold mb-3">Terms & Policies</h1>
          <p className="text-white/60 text-base sm:text-lg">Please review the following</p>
        </div>

        {/* Terms List */}
        <div className="space-y-8 sm:space-y-10">
          {termsData.map((term) => (
            <div key={term.id} className="space-y-4">
              <h2 className="text-xl sm:text-2xl font-semibold">
                {term.id}. {term.title}
              </h2>

              {typeof term.description === 'string' ? (
                <p className="text-white/80 leading-relaxed">{term.description}</p>
              ) : (
                term.description
              )}


              {term.subPoints && term.subPoints.length > 0 && (
                <ul className="space-y-2 ml-4 sm:ml-6 list-disc list-outside">
                  {term.subPoints.map((point, index) => (
                    <li
                      key={index}
                      className="text-white/80 leading-relaxed"
                    >
                      {point}
                    </li>
                  ))}
                </ul>
              )}


              {term.footer && (
                <p className="text-white/80 leading-relaxed mt-3">{term.footer}</p>
              )}
            </div>
          ))}
        </div>

        {/* Bottom spacing */}
        <div className="h-16"></div>
      </div>
    </div>
  );
};

export default TermsAndPolicies;

